/**
 * Highcharts options for the web-aligned received-requests report.
 * Theme-aware text/background colors for light and dark mode.
 */
export function buildRequestsReceivedWebReportChartOptions({
  categories = [],
  receivedSeries = [],
  transferredSeries = [],
  isDark = false,
  title = "تقرير استلام الطلبات",
}) {
  const textColor = isDark ? "#E8EAED" : "#1F2937";
  const subtleText = isDark ? "#B0B7C3" : "#6B7280";
  const gridColor = isDark ? "rgba(255,255,255,0.08)" : "rgba(15,23,42,0.08)";
  const bgColor = isDark ? "#1E1E1E" : "#FFFFFF";
  const borderColor = isDark ? "#3A3A3A" : "#E5E7EB";

  return {
    chart: {
      type: "column",
      backgroundColor: bgColor,
      style: { fontFamily: "inherit" },
      spacing: [16, 16, 16, 16],
    },
    title: {
      text: title,
      style: { color: textColor, fontSize: "18px", fontWeight: "700" },
    },
    xAxis: {
      categories,
      labels: {
        style: { color: textColor, fontSize: "12px" },
        rotation: categories.length > 12 ? -35 : 0,
      },
      lineColor: gridColor,
      tickColor: gridColor,
    },
    yAxis: {
      min: 0,
      title: {
        text: "عدد الطلبات",
        style: { color: subtleText, fontWeight: "600" },
      },
      labels: { style: { color: textColor } },
      gridLineColor: gridColor,
      stackLabels: {
        enabled: true,
        style: {
          color: textColor,
          fontWeight: "bold",
          textOutline: isDark ? "1px contrast" : "none",
        },
      },
    },
    legend: {
      align: "right",
      verticalAlign: "top",
      itemStyle: { color: textColor, fontWeight: "600" },
      itemHoverStyle: { color: isDark ? "#FFFFFF" : "#111827" },
      backgroundColor: bgColor,
      borderColor,
      borderWidth: 1,
      borderRadius: 8,
      padding: 10,
    },
    tooltip: {
      backgroundColor: isDark ? "#2A2A2A" : "#FFFFFF",
      borderColor,
      style: { color: textColor },
      headerFormat: '<span style="font-size:13px;font-weight:700">{point.key}</span><br/>',
      pointFormat:
        '<span style="color:{series.color}">\u25CF</span> {series.name}: <b>{point.y}</b><br/>',
      footerFormat: 'المجموع: <b>{point.stackTotal}</b>',
      shared: false,
      useHTML: true,
    },
    plotOptions: {
      column: {
        stacking: "normal",
        borderRadius: 4,
        dataLabels: {
          enabled: true,
          style: {
            color: textColor,
            fontWeight: "600",
            textOutline: isDark ? "1px rgba(0,0,0,0.85)" : "1px rgba(255,255,255,0.9)",
          },
        },
      },
    },
    series: [
      {
        name: "الطلبات المحولة",
        color: "#3B82F6",
        data: transferredSeries,
      },
      {
        name: "الطلبات المستلمة",
        color: "#22C55E",
        data: receivedSeries,
      },
    ],
    credits: { enabled: false },
  };
}

export function extractReceivedWebReportChartSeries(payload = {}) {
  return {
    categories: payload.chartUsers || [],
    receivedSeries: payload.chartValuesReceived || payload.chartValues || [],
    transferredSeries:
      payload.chartValuesTransferred || payload.chartValues2 || [],
    totals: {
      received:
        payload.sum_of_transferred_requests ??
        payload.sum_of_transfered_requests ??
        0,
      transferred:
        payload.sum_of_received_requests ??
        payload.sum_of_recieved_requests ??
        0,
      total: payload.total_sum ?? 0,
    },
  };
}
